import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Form} from 'react-final-form';
import classNames from 'classnames';
import isEqual from 'lodash/isEqual';
import {ASSET_TYPE_IMAGE, ASSET_TYPE_VIDEO} from '../../../configs/constants';
import {Button, Link, ThemeContext, SaveButton} from '../../common';
import QuestionImage from './QuestionImage';
import QuestionVideo from './QuestionVideo';
import QuestionImageModal from './QuestionImageModal';
import QuestionAnswer from './QuestionAnswer';

export default class Question extends PureComponent {
  static propTypes = {
    onAnswerSelected: PropTypes.func.isRequired,
    onAnswerConfirm: PropTypes.func.isRequired,
    onLeaveGame: PropTypes.func.isRequired,
    questionIndex: PropTypes.number,
    question: PropTypes.shape({
      text: PropTypes.string.isRequired,
      answers: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          text: PropTypes.string.isRequired,
        })
      ),
      asset: PropTypes.shape({
        url: PropTypes.string,
        title: PropTypes.string,
        type: PropTypes.string,
      }),
    }),
    isCurrentPlayerTurn: PropTypes.bool.isRequired,
    isAnswerChecking: PropTypes.bool.isRequired,
    isVideoPlaying: PropTypes.bool.isRequired,
    onPause: PropTypes.func.isRequired,
    onPlay: PropTypes.func.isRequired,
  };

  static defaultProps = {
    questionIndex: 0,
    question: {
      asset: {},
      answers: [],
    },
  };

  state = {
    isImagePreviewOpened: false,
    videoEnded: false,
    formData: {},
  };

  componentWillReceiveProps(nextProps) {
    const {question: {answers: newAnswers}} = nextProps;
    const {question: {answers: oldAnswers}} = this.props;

    if (newAnswers && !isEqual(oldAnswers, newAnswers)) {
      const selectedAnswer = newAnswers.find(answer => answer.isChosen);
      const selectedAnswerId = Boolean(selectedAnswer) && selectedAnswer.id;

      this.setState({formData: {answer: selectedAnswerId}});
    }
  }

  onVideoEnded = () => {
    this.setState({videoEnded: true});
  };

  onPreviewClose = () => {
    this.setState({isImagePreviewOpened: false});
  };

  onPreviewOpen = () => {
    this.setState({isImagePreviewOpened: true});
  };

  onFormSubmit = (values) => {
    const {onAnswerConfirm} = this.props;
    const {answer} = values;

    if (!answer) {return;}

    onAnswerConfirm(answer);
  };

  renderAnswers = answers => (
    <div className="question__radiobox">
      {Boolean(answers) && answers.map(this.renderAnswer)}
    </div>
  );

  renderAnswer = ({id, text, isCorrect, isChosen}) => {
    const {
      isCurrentPlayerTurn,
      onAnswerSelected,
      isAnswerChecking,
      isVideoPlaying,
    } = this.props;

    const classes = classNames(
      {
        question__answer_correct: Boolean(isCorrect),
        question__answer_selected: Boolean(isChosen),
      }
    );

    return (
      <QuestionAnswer
        id={id}
        text={text}
        className={classes}
        isCorrect={Boolean(isCorrect)}
        isVideoPlaying={isVideoPlaying}
        key={id}
        disabled={!isCurrentPlayerTurn || isAnswerChecking}
        onAnswerSelected={onAnswerSelected}
      />
    );
  };

  render() {
    const {isImagePreviewOpened, formData} = this.state;
    const {
      question: {
        text,
        answers,
        asset,
      },
      questionIndex,
      isCurrentPlayerTurn,
      isAnswerChecking,
      isVideoPlaying,
      onLeaveGame,
      onPause,
      onPlay,
    } = this.props;
    const {url, title, type} = asset || {}; // can be null
    const lobbyLink = '/lobby';
    const showImage = Boolean(asset) && (type === ASSET_TYPE_IMAGE);
    const showVideo = Boolean(asset) && (type === ASSET_TYPE_VIDEO);

    return (
      <ThemeContext.Consumer>
        {(theme) => {
          const {primaryColor, secondaryColor} = theme;
          const numberStyles = {color: primaryColor};
          const questionStyles = {color: secondaryColor};

          return (
            <div className="game__question-wrap">
              <div className="game__question">
                <div className="question__number" style={numberStyles}>
                  Question&nbsp;<b>{questionIndex + 1}</b>
                </div>
                <div className="question__text" style={questionStyles}>{text}</div>
                {showImage && <QuestionImage
                  url={url}
                  title={title}
                  onPreviewClicked={this.onPreviewOpen}
                />}
                {showVideo && <div className="text-center row_gap_s">
                  <QuestionVideo
                    autoPlay
                    url={url}
                    onPause={onPause}
                    onPlay={onPlay}
                    isVideoPlaying={isVideoPlaying}
                  />
                </div>
                }
                <Form
                  onSubmit={this.onFormSubmit}
                  initialValues={formData}
                  validateOnBlur={false}
                  render={(params) => {
                    const {handleSubmit, values: {answer}} = params;
                    return (
                      <form onSubmit={handleSubmit}>
                        {this.renderAnswers(answers)}
                        {isCurrentPlayerTurn &&
                          <SaveButton
                            size="l"
                            type="submit"
                            text="Answer"
                            disabled={!answer || isAnswerChecking}
                          />}
                      </form>
                    );
                  }}
                />
              </div>
              <div>
                <div className="text-center row_gap_s">
                  <Link color="#999999" to={lobbyLink} type="game__return" text="> Return to lobby"/>
                </div>
                <div className="text-center">
                  <Button handler={onLeaveGame} className="button_size_l" text="Leave"/>
                </div>
              </div>
              {showImage && <QuestionImageModal
                isModalOpened={isImagePreviewOpened}
                onModalClose={this.onPreviewClose}
                url={url}
                title={title}
              />}
            </div>
          );
        }}
      </ThemeContext.Consumer>
    );
  }
}
